@import '../../themes/capsule.globals';

:host {
  --pill-text-color: var(--cpsl-pill-text);
  --pill-text-size: #{dynamic-font-clamp(1, 10px, 1.5)};
  --pill-text-line-height: 100%;

  --pill-container-height: 18px;
  --pill-container-background-color: var(--cpsl-color-pill-container-background);
  --pill-container-border-color: var(--cpsl-color-pill-container-border);
  --pill-container-padding-start: 8px;
  --pill-container-padding-end: 8px;
  --pill-container-border-radius: var(--cpsl-border-radius-pill);

  font-family: $font-family-base;
  display: inline-block;
}

.pill-container {
  @include padding(var(--pill-container-padding-top), var(--pill-container-padding-end), var(--pill-container-padding-bottom), var(--pill-container-padding-start));

  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  height: var(--pill-container-height);

  background: var(--pill-container-background-color);
  border: 1px solid;
  border-color: var(--pill-container-border-color);
  border-radius: var(--pill-container-border-radius);

  color: var(--pill-text-color);
  font-size: var(--pill-text-size);
  line-height: var(--pill-text-line-height);

  span {
    display: inline-block;
  }
}
